<div class="filter-selector-wrapper">
  <div class="filter-toggle">
    <button mat-button (click)="toggleShowFilter()">
      <svg width="16" height="16" x="0" y="0" viewBox="8 3.56 16 16">
        <path d="M8 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1z" />
        <path d="M12 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1z" />
        <path
          d="M16.56 16c-.58 0-1.06.45-1.06 1s.48 1 1.06 1h6.38c.58 0 1.06-.45 1.06-1s-.48-1-1.06-1h-6.38z"
        />
      </svg>
      {{ 45 | translate }}
    </button>
  </div>
  <div class="activ-filters">
    @if (rating && rating > 1) {
      <button
        mat-button
        class="chip rating"
        matTooltip="{{ 39 | translate }}"
        (click)="changeRatingFilter(0)"
      >
        Minst {{ rating }} ★
      </button>
    }
    @if (customerRating && customerRating > 1) {
      <button
        mat-button
        class="chip customer-rating"
        matTooltip="{{ 39 | translate }}"
        (click)="changeCustomerRatingFilter(0)"
      >
        {{ customerRating }} +
      </button>
    }
    @if (selectedSearchFilters && searchFilterFormControl) {
      @for (item of searchFilters; track item) {
        @if (selectedSearchFilters.indexOf(item.Id) > -1) {
          <button
            mat-button
            class="chip type"
            (click)="removeSearchFilter(item.Id)"
            matTooltip="{{ 39 | translate }} {{ item.Name }}"
          >
            {{ item.Name }}
          </button>
        }
      }
    }

    <!-- @if (selectedFacilities && facilityFormControl) {
      @for (item of facilities; track item) {
        @if (selectedFacilities.indexOf(item.Id) > -1) {
          <button
            mat-button
            class="chip facility"
            (click)="removeFacility(item.Id)"
            matTooltip="{{ 39 | translate }} {{ item.Name }}"
          >
            {{ item.Name }}
          </button>
        }
      }
    } -->
  </div>
</div>
@if (showFilter) {
  <div id="filters" class="{{ showFilter ? 'show' : 'hide' }}">
    <div class="overlay" (click)="toggleShowFilter()"></div>
    <div class="filter-content">
      <button aria-label="Stäng" class="close" (click)="toggleShowFilter()">
        X
      </button>
      <p class="filter-content-header">{{ 45 | translate }}</p>
      <div class="filter">
        <div class="rating">
          <mat-label>{{ 18 | translate }}</mat-label>
          <mat-radio-group
            [(ngModel)]="rating"
            (ngModelChange)="changeRatingFilter(rating)"
          >
            @for (item of [1, 2, 3, 4, 5]; track item) {
              <mat-radio-button
                [value]="item"
                matTooltip="Minst {{ item }} {{
                  item == 1 ? (54 | translate) : (55 | translate)
                }}"
              >
                {{ getRating(item) }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
      <div class="filter">
        <div class="rating">
          <mat-label>{{ 53 | translate }}</mat-label>
          <mat-radio-group
            [(ngModel)]="customerRating"
            (ngModelChange)="changeCustomerRatingFilter(customerRating)"
          >
            @for (item of [0, 6, 7, 8, 9]; track item) {
              <mat-radio-button [value]="item" matTooltip="Minst {{ item }}">
                {{ getCustomerRating(item) }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
      @if (settings.ClientId != 4) {
        <div class="filter">
          <div class="location">
            <mat-form-field appearance="outline">
              <mat-label>{{ 19 | translate }}</mat-label>
              <mat-select
                [(value)]="location"
                (selectionChange)="changeLocation(location)"
              >
                @for (location of locations; track location) {
                  <mat-option [value]="location.Url">{{
                    location.Name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      @if (pois && pois.length > 0) {
        <div class="filter">
          <div id="poi">
            <mat-form-field appearance="outline">
              <mat-label>{{ 20 | translate }}</mat-label>
              <mat-select [(value)]="poi" (selectionChange)="changePoi(poi)">
                @for (poi of pois; track poi) {
                  <mat-option [value]="poi.Url">{{ poi.Name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      @if (selectedSearchFilters) {
        <div class="filter">
          <div id="property-type">
            <mat-label>{{ 38 | translate }}</mat-label>
            @for (item of getPropertyTypes(); track item) {
              <!-- {{ item | json }}
              item.Selected = {{ item.Selected }} -->
              <mat-checkbox
                (change)="changeSearchFilter(item.Id, $event)"
                [value]="item.Id.toString()"
                [(ngModel)]="item.Selected"
                >{{ item.Name }}</mat-checkbox
              >
            }
          </div>
        </div>
      }
      @if (selectedFacilities) {
        <div class="filter">
          <div id="facilities">
            <mat-label>{{ 35 | translate }}</mat-label>
            @for (item of getFacilities(); track item) {
              <mat-checkbox
                (change)="changeSearchFilter(item.Id, $event)"
                [value]="item.Id.toString()"
                [(ngModel)]="item.Selected"
                >{{ item.Name }}</mat-checkbox
              >
            }
          </div>
        </div>
      }
    </div>
  </div>
}
